{
  "buttonNext": "Далі",
  "buttonFinish": "Завершити",
  "Text": {
    "selfDiscoveryIntro": [
      {
        "title": "Ласкаво просимо до Healthy Mind 🧠",
        "desc": "Це простір турботи про себе — місце, де можна зупинитися, видихнути й прислухатись до своїх почуттів.\n\nЧекап допоможе вам краще зрозуміти себе, знайти опору та побачити, як саме ви можете підтримати себе вже зараз.",
        "buttonNext": "Далі",
        "content": {
          "image": "1"
        }
      },
      {
        "title": "Кожна відповідь — наближує вас до розуміння",
        "desc": "Система підлаштовується під ваш поточний стан, формуючи індивідуальний шлях проходження.\n\nЗавдяки цьому доказовий чекап залишається простим і точним: він справді відображає те, як ви почуваєтесь, а проходження займає в середньому 8 хвилин.\n\nПісля завершення ви отримаєте зрозуміле пояснення свого стану та персоналізовані рекомендації сформовані практикуючими психологами, що можуть стати в нагоді вже сьогодні.",
        "buttonNext": "Далі",
        "content": {
          "image": "2"
        }
      },
      {
        "title": "Простір, де можна бути собою",
        "desc": "Ваші відповіді залишаються тільки з вами — ми гарантуємо повну конфіденційність.\nВід вас потрібна лише щирість з собою, від нас — безпечний простір.\n\nМи створили Healthy Mind, щоби ви могли відчути: тут можна бути справжнім.",
        "buttonNext": "Розпочати",
        "content": {
          "image": "3"
        }
      }
    ]
  }
}
